import React from 'react';
import {IRegulationComponents} from "./regulation-components.interface";
import {
    HeaderWelcomeLoginButtonComponentProps
} from "../../components/header/buttons/login-button/header-login-button.component.props";
import {
    HeaderWelcomeRegisterButtonComponentProps
} from "../../components/header/buttons/register-button/header-register-button.component.props";
import {
    HeaderLoginButtonComponent
} from "../../components/header/buttons/login-button/header-login-button.component";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {
    HeaderRegisterButtonComponent
} from "../../components/header/buttons/register-button/header-register-button.component";

export class RegulationComponentsCommon implements IRegulationComponents {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    renderHeaderLoginButton(props: HeaderWelcomeLoginButtonComponentProps): React.ReactElement {
        return (
            <HeaderLoginButtonComponent {...props}/>
        );
    }

    renderHeaderRegisterButton(props: HeaderWelcomeRegisterButtonComponentProps): React.ReactElement {
        return (
            <HeaderRegisterButtonComponent {...props}/>
        );
    }

}